const FPNetLogo: React.FC<{ className?: string }> = ({className = "mx-auto h-32 w-auto"}) => {
    return <img
        className={className}
        src={`${process.env.PUBLIC_URL}/images/FPnet_logo_HR_L.svg`}
        alt="FPNet"
    />
}
export default FPNetLogo;